import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { getTariffParams } from '../model/tariff.model'
import { fetchTariffs, setSelectedTariff } from '../store/tariff.reducer'
import {
  selectTariffError,
  selectTariffLoading,
  getTariffParamSelector,
} from '../store/tariff.selectors'

import { Tariff } from '~/basket/model/lines/tariff/tariff.model'
import { RootState } from '~/core/store/root.reducer'
import {
  selectTariffsWithFormattedPrices,
  selectSelectedTariffWithFormattedPrices,
} from '~/prices/prices.selectors'

interface useTariff {
  getTariffs: () => unknown
  setTariff: (tariff: Tariff | null) => unknown
  tariffs: Tariff[]
  loading: boolean | null
  errorCode: number
  errorMessage: string
  selectedTariff?: Tariff
}

export default function useTariff(id: string): useTariff {
  const dispatch = useDispatch()

  const params: getTariffParams = useSelector(getTariffParamSelector)

  const selectedTariff = useSelector((state: RootState) =>
    selectSelectedTariffWithFormattedPrices(state, id),
  )
  const getTariffs = () => dispatch(fetchTariffs({ id, params }))

  useEffect(() => {
    if (!selectedTariff) getTariffs()
  }, [])

  return {
    getTariffs,
    setTariff: (tariff: Tariff | null) =>
      dispatch(setSelectedTariff({ id, selectedTariffId: tariff ? tariff.id : '' })),
    tariffs: useSelector((state: RootState) => selectTariffsWithFormattedPrices(state, id)),
    ...useSelector((state: RootState) => selectTariffError(state, id), shallowEqual),
    loading: useSelector((state: RootState) => selectTariffLoading(state, id)),
    selectedTariff,
  }
}
